<div class="p-8">
    <p-card class="grid">
        <div class="flex gap-4">
            <button pButton
                    pRipple
                    label="Add Company"
                    class="p-button"
                    (click)="addCompany()"></button>
        </div>
        <p-table responsiveLayout="scroll"
                 [metaKeySelection]="true"
                 dataKey="code"
                 [stripedRows]="true"
                 [value]="userManagementService.companies">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 5rem"></th>
                    <th>
                        <div class="icon-title-th"><label>Company Name</label></div>
                    </th>
                    <th>
                        <div class="icon-title-th"><label>Company Code</label></div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-company
                         let-i="rowIndex"
                         let-expanded="expanded">
                <tr>
                    <td>
                        <button type="button"
                                pButton
                                pRipple
                                [pRowToggler]="company"
                                class="p-button-text p-button-rounded p-button-plain"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td>{{company.name}}</td>
                    <td>{{company.code}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="expandedrow"
                         let-company>
                <tr>
                    <td colspan="12">
                        <div>
                            <p-table [value]="company.products">
                                <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="icon-title-th">
                            <small>Products</small><br/>
                            {{company.products?.length > 0 ? company.products.join(", ") : "No products for this company"}}
                        </div>
                    </th>

                    <th style="text-align:right;">
                        <p-splitButton label="Edit"
                                       icon="fa fa-pencil"
                                       (onClick)="openUpdateCompanyDialog(company)"
                                       appendTo="body"
                                       [model]="companyButtonItems"
                                       (onDropdownClick)="setTargetCompany(company)">
                        </p-splitButton>
                    </th>
                </tr>
            </ng-template>
        </p-table>
</div>
<br />
<div style="margin-left: 8%;">
</div>
<p-table [value]="company.roles">
    <ng-template pTemplate="header">
        <tr>
            <th>
                <div class="icon-title-th"><label>Role</label></div>
            </th>
            <th>
                <div class="icon-title-th"><label>Permissions</label></div>
            </th>
            <th>
                <div class="icon-title-th"><label>Products</label></div>
            </th>
            <th>

            </th>

        </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-role>
        <tr>
            <td>{{role.name}}</td>
            <div
                 *ngIf="role.permissions && role.permissions?.length > 0; then thenDisplayPermissions else noPermissions">
            </div>
            <ng-template #thenDisplayPermissions>
                <td>
                    <li *ngFor="let permission of role.permissions">{{permission}}</li>
                </td>
            </ng-template>
            <ng-template #noPermissions>
                <td>
                    <div class="icon-title-th">No permissions have been added yet</div>
                </td>
            </ng-template>
            <div *ngIf="role.products && role.products?.length > 0; then displayProducts else noProducts">
            </div>
            <ng-template #displayProducts>
                <td>
                    <li *ngFor="let product of role.products">{{product}}</li>
                </td>
            </ng-template>
            <ng-template #noProducts>
                <td>
                    <div class="icon-title-th">No products have been added yet</div>
                </td>
            </ng-template>
            <td style="text-align:right;">
                <p-splitButton label="Edit"
                               icon="fa fa-pencil"
                               (onClick)="openUpdateRoleDialog(company, role)"
                               appendTo="body"
                               [model]="roleButtonItems"
                               (onDropdownClick)="setTargetRole(role)">
                </p-splitButton>
            </td>
        </tr>
    </ng-template>
</p-table>
<div class="row">
    <div class="p-col-12 p-ml-2">
        <button pButton
                type="button"
                class="p-button-rounded p-button-text"
                icon="pi pi-plus"
                (click)="openRoleCreationDialog(company)">
        </button>
    </div>
</div>
</td>
</tr>
</ng-template>
</p-table>
</p-card>
</div>

<!-- Add Company Dialog -->
<p-dialog [(visible)]="companyDialog"
          [modal]="true"
          [header]="newCompany ? 'Create New Company' : `Update ${editCompany?.name}`"
          styleClass="p-fluid"
          id="dialog"
          [draggable]="false"
          [resizable]="true"
          [style]="{width: '400px'}"
          closeAriaLabel="CloseDialog">
    <ng-template pTemplate="content">
        <div class="grid gap-4 grid-cols-1 pt-2">
            <div class="row p-grid"
                 *ngIf="newCompany">
                <p-floatlabel variant="on">
                    <input type="text"
                           class="w-full"
                           pInputText
                           required
                           (input)="onCompanyNameInput($event)"
                           [ngClass]="{'ng-invalid': invalidCompanyName}"
                           [(ngModel)]="editCompany.name" />
                    <label>Company Name *</label>
                </p-floatlabel>
                <small aria-label="error-string"
                       *ngIf="invalidCompanyName"
                       class="invalid-input-message">
                    Can only contain letters, numbers, spaces, -, and _.<br />
                    Must begin and end with a letter or number.<br />
                </small>
            </div>
            <div class="row p-grid"
                 *ngIf="newCompany">
                <p-floatlabel variant="on">
                    <input type="text"
                           class="w-full"
                           pInputText
                           (input)="onCompanyCodeInput($event)"
                           [ngClass]="{'ng-invalid': invalidCompanyCode}"
                           [(ngModel)]="editCompany.code" />
                    <label>Company Code *</label>
                </p-floatlabel>
                <small aria-label="error-string"
                       *ngIf="invalidCompanyCode"
                       class="invalid-input-message">
                    Can only contain letters and numbers.<br />
                    Can not be empty.
                </small>
            </div>
            <div class="row p-grid">
                <p-floatlabel variant="on">
                    <p-multiSelect appendTo="body"
                                   [options]="this.productService.productPermissionPrefixes"
                                   [required]="false"
                                   class="w-full"
                                   [(ngModel)]="editCompany.products">
                    </p-multiSelect>
                    <label>Products</label>
                </p-floatlabel>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton
                pRipple
                label="Cancel"
                class="p-button-outlined"
                (click)="hideDialog()"></button>
        <button pButton
                pRipple
                label="Save"
                class="p-button"
                (click)="saveCompany()"
                [disabled]="invalidCompanyCode || !editCompany.name || !editCompany.code || invalidCompanyName || editCompany.products.length === 0"></button>
    </ng-template>
</p-dialog>


<p-dialog [(visible)]="roleDialog"
          [modal]="true"
          [header]="newRole ? 'Create New Role' : `Update ${editRole?.name}`"
          styleClass="p-fluid"
          id="dialog"
          [draggable]="false"
          [resizable]="true"
          [style]="{width: '400px'}"
          closeAriaLabel="CloseDialog">
    <ng-template pTemplate="content">
        <div class="grid gap-4 grid-cols-1 pt-2">
            <div class="row p-grid"
                 *ngIf="newRole">
                <p-floatlabel variant="on">
                    <p-autoComplete [(ngModel)]="editRole.company"
                                    [suggestions]="suggestedCompanies"
                                    (completeMethod)="searchCompanies($event)"
                                    completeOnFocus='false'
                                    [dropdown]="true"
                                    [required]="true"
                                    appendTo="body"
                                    class="w-full"
                                    field="name"
                                    (onSelect)="onChangeCompany($event)">
                    </p-autoComplete>
                    <label>Company Name *</label>
                </p-floatlabel>
            </div>
            <div class="row p-grid"
                 *ngIf="newRole">
                <p-floatlabel variant="on">
                    <input type="text"
                           class="w-full"
                           pInputText
                           [(ngModel)]="editRole.name" />
                    <label>Role Name *</label>
                </p-floatlabel>
            </div>
            <div class="row p-grid">
                <p-floatlabel variant="on">
                    <p-multiSelect appendTo="body"
                                   [options]="groupedPermissions"
                                   [group]="true"
                                   [required]="false"
                                   class="w-full"
                                   [(ngModel)]="editRole.permissions">
                    </p-multiSelect>
                    <label>Permissions</label>
                </p-floatlabel>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton
                pRipple
                label="Cancel"
                class="p-button-outlined"
                (click)="hideDialog()"></button>
        <button pButton
                pRipple
                label="Save"
                class="p-button"
                (click)="saveRole()"
                [disabled]="!editRole.name"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="deleteCompanyDialog"
          [modal]="true"
          header="Delete Company"
          styleClass="p-fluid"
          id="dialog"
          [draggable]="false"
          [resizable]="true"
          [style]="{width: '400px'}"
          closeAriaLabel="CloseDialog">
    <ng-template pTemplate="content">
        <p>Are you sure you want to delete <b>{{targetCompany.name}}</b>?</p>
        <p>This action is irreversible.</p>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton
                pRipple
                label="Cancel"
                class="p-button-outlined p-mr-2"
                (click)="hideDialog()"></button>
        <button pButton
                pRipple
                label="Delete"
                class="p-button p-ml-2"
                (click)="deleteCompany()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="deleteRoleDialog"
          [modal]="true"
          header="Delete Role"
          styleClass="p-fluid"
          id="dialog"
          [draggable]="false"
          [resizable]="true"
          [style]="{width: '400px'}"
          closeAriaLabel="CloseDialog">
    <ng-template pTemplate="content">
        <p>Are you sure you want to delete <b>{{targetRole.name}}</b>?</p>
        <p>This action is irreversible.</p>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton
                pRipple
                label="Cancel"
                class="p-button-outlined p-mr-2"
                (click)="hideDialog()"></button>
        <button pButton
                pRipple
                label="Delete"
                class="p-button p-ml-2"
                (click)="deleteRole()"></button>
    </ng-template>
</p-dialog>